<template>
  <div>
    <v-row justify="center">
      <v-col class="col-auto text-subtitle-1 text-center">
        <div>本場總共預約人數：{{ list.length }}</div>
        <div>
          三高異常人數：{{
            list.filter(
              (person) =>
                (person.血液報告.血脂 &&
                  person.血液報告.血脂.abnormal.length) ||
                (person.血液報告.血壓 &&
                  person.血液報告.血壓.abnormal.length) ||
                (person.血液報告.血糖 && person.血液報告.血糖.abnormal.length)
            ).length
          }}
        </div>
        <div>
          肝功能異常人數：{{
            list.filter(
              (person) =>
                person.血液報告.肝 && person.血液報告.肝.abnormal.length
            ).length
          }}
        </div>
        <div>
          腎臟指數異常人數：{{
            list.filter(
              (person) =>
                person.血液報告.腎 && person.血液報告.腎.abnormal.length
            ).length
          }}
        </div>
        <div class="mt-4">
          列印
          <v-text-field
            v-model="startNum"
            dense
            outlined
            hide-details
            class="d-inline-block"
            style="width: 50px"
          ></v-text-field>
          號 -
          <v-text-field
            v-model="endNum"
            dense
            outlined
            hide-details
            class="d-inline-block"
            style="width: 50px"
          ></v-text-field>
          號
        </div>
        <div>
          列印頁數共
          {{
            printType == "m"
              ? filterList.filter(
                  (person) =>
                    (person.血液報告.血脂 &&
                      person.血液報告.血脂.abnormal.length) ||
                    (person.血液報告.血壓 &&
                      person.血液報告.血壓.abnormal.length) ||
                    (person.血液報告.血糖 &&
                      person.血液報告.血糖.abnormal.length)
                ).length +
                filterList.filter(
                  (person) =>
                    person.血液報告.肝 && person.血液報告.肝.abnormal.length
                ).length +
                filterList.filter(
                  (person) =>
                    person.血液報告.腎 && person.血液報告.腎.abnormal.length
                ).length
              : filterList.filter(
                  (person) =>
                    (person.血液報告.血脂 &&
                      person.血液報告.血脂.abnormal.length) ||
                    (person.血液報告.血壓 &&
                      person.血液報告.血壓.abnormal.length) ||
                    (person.血液報告.血糖 &&
                      person.血液報告.血糖.abnormal.length) ||
                    (person.血液報告.腎 &&
                      person.血液報告.腎.abnormal.length) ||
                    (person.血液報告.肝 && person.血液報告.肝.abnormal.length)
                ).length
          }}
          頁
        </div>
        <div class="text-center mt-4">
          <v-btn
            ref="btnPrint"
            v-print="printObj"
            color="primary"
            class="d-none"
          >
            第二階段轉診複檢列印
          </v-btn>
          <v-btn color="primary" @click="download"
            >第二階段{{ printType == "m" ? "轉診" : "複檢" }}單列印</v-btn
          >
        </div>
      </v-col>
    </v-row>
    <div class="preLoad">
      <img src="/print/轉診單.jpg" alt="" />
      <img src="/print/複檢單.jpg" alt="" />
    </div>
    <section id="printBlock">
      <div
        class="onlyPrint text-left"
        v-for="person of filterList"
        v-if="person && section"
      >
        <template v-if="printType == 'm'">
          <Page
            :config="Items.轉診單(person, section, '三高')"
            v-if="
              (person.血液報告.血脂 && person.血液報告.血脂.abnormal.length) ||
              (person.血液報告.血壓 && person.血液報告.血壓.abnormal.length) ||
              (person.血液報告.血糖 && person.血液報告.血糖.abnormal.length)
            "
          />
          <Page
            :config="Items.轉診單(person, section, '肝')"
            v-if="person.血液報告.肝 && person.血液報告.肝.abnormal.length"
          />
          <Page
            :config="Items.轉診單(person, section, '腎')"
            v-if="person.血液報告.腎 && person.血液報告.腎.abnormal.length"
          />
        </template>
        <template v-if="printType == 's'">
          <Page
            :config="Items.複檢單(person, section)"
            v-if="
              (person.血液報告.血脂 && person.血液報告.血脂.abnormal.length) ||
              (person.血液報告.血壓 && person.血液報告.血壓.abnormal.length) ||
              (person.血液報告.血糖 && person.血液報告.血糖.abnormal.length) ||
              (person.血液報告.腎 && person.血液報告.腎.abnormal.length) ||
              (person.血液報告.肝 && person.血液報告.肝.abnormal.length)
            "
          />
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import dayjs from "dayjs";
import print from "vue-print-nb";
import Page from "@/components/Print/page";
import Items from "@/libs/printItems";

const 年度 = dayjs().get("year") - 1911;
export default {
  name: "Print",
  directives: {
    print,
  },
  components: { Page },
  props: ["list", "section", "printType"],
  data: () => ({
    Items,
    startNum: 0,
    endNum: 0,
    printObj: {
      id: "#printBlock",
      extraCss: `/vendor/vuetify/vuetify.min.css`,
    },
  }),
  computed: {
    filterList() {
      return this.list.filter(
        (person) =>
          parseInt(person.報到號碼) >= this.startNum &&
          parseInt(person.報到號碼) <= this.endNum
      );
    },
  },
  async created() {
    this.startNum = 1;
    this.endNum = this.list.length;
  },
  methods: {
    async download() {
      this.$nextTick(() => {
        this.$refs.btnPrint.$el.click();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen {
  .onlyPrint {
    margin: 0;
    padding: 0;
    display: none;
  }
}
@media print {
  .noPrint {
    display: none;
  }
  .onlyPrint {
    display: block;
  }
}

#printBlock {
  position: relative;
  margin: 0;
  padding: 0;
  // color: red;
}
.preLoad {
  width: 0;
  height: 0;
  overflow: hidden;
}
</style>
